<template>
    <form  @submit.prevent="validar">
        <fieldset :disabled="!enabled || cargando">
            <div class="ml-3 row">
                <div class="col-md-12 col-12">
                    <div class="form-group">
                        <label><i class="fa fa-asterisk text-danger"></i>Banco de destino</label>
                        <combo-box v-model="formulario.banco" :opciones="lstBancos" name="banco"
                                   v-validate="{required:true,obj:true}"></combo-box>
                        <span class="form-text text-danger">{{ errors.first('banco') }}</span>
                        <input type="hidden" v-model="formulario.banco.num" ref="cuenta" name="cuenta">
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="beneficiario"><i class="fa fa-asterisk text-danger "></i>Beneficiario</label>
                        <input type="text" class="form-control" :class="errors.has('beneficiario') && 'is-invalid'" id="beneficiario" name="beneficiario" v-model="formulario.beneficiario" v-validate="{required:true,alpha_spaces:true}" placeholder="ASIAUTO SA"/>
                        <span class="form-text text-danger">{{ errors.first('beneficiario') }}</span>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="númerodc"><i class="fa fa-asterisk text-danger"></i>Nº Cuenta</label>
                        <input type="text" class="form-control" :class="errors.has('número de cuenta') && 'is-invalid'" name="número de cuenta" id="númerodc" v-model="formulario.cuenta" v-validate="{required:true,alpha_dash:true,confirmed:'cuenta'}" placeholder="1235467890"/>
                        <span class="form-text text-danger">{{ errors.first('número de cuenta') }}</span>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="númerodco"><i class="fa fa-asterisk text-danger"></i>Nº de comprobante</label>
                        <input type="text" class="form-control" :class="errors.has('número de comprobante') && 'is-invalid'" name="número de comprobante" id="númerodco" v-model="formulario.comprobante" v-validate="{required:true,alpha_dash:true}" placeholder="1231-A123"/>
                        <span class="form-text text-danger">{{ errors.first('número de comprobante') }}</span>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="email">Email beneficiario</label>
                        <input type="email" class="form-control" :class="errors.has('email') && 'is-invalid'" name="email" id="email" placeholder="ventas@asiauto.com.ec" v-model="formulario.email" v-validate="{email:true}"/>
                        <span class="form-text text-danger">{{ errors.first('email') }}</span>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="fecha"><i class="fa fa-asterisk text-danger"></i>Fecha de transacción</label>
                        <input type="tel" class="form-control" :class="errors.has('fecha') && 'is-invalid'"  name="fecha" id="fecha" placeholder="dd/mm/yyyy" v-model="formulario.fecha" v-validate="{required:true,date_format:'dd/MM/yyyy',date_between:[maximaFecha,minimaFecha,true]}" v-mask="'##/##/####'"/>
                        <span class="form-text text-danger">{{ errors.first('fecha') }}</span>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="monto"><i class="fa fa-asterisk text-danger"></i>Monto de pago</label>
                        <input type="number" class="form-control" :class="errors.has('monto') && 'is-invalid'" name="monto" id="monto" placeholder="5612.34" min="0" step="any" v-model="formulario.monto" v-validate="{required:true,decimal:2,max_value:maximo,min_value:0}"/>
                        <span class="form-text text-danger">{{ errors.first('monto') }}</span>
                    </div>
                </div>
                <div class="col-md-12 col-12">
                    <div class="form-group">
                        <label for="comprobante"><i class="fa fa-asterisk text-danger"></i>Subir comprobante de pago</label>
                        <archivo v-model="formulario.archivo" :class="errors.has('comprobante') && 'is-invalid'" name="comprobante" id="comprobante" v-validate="{required:true}"></archivo>
                        <span class="form-text text-danger">{{ errors.first('comprobante') }}</span>
                    </div>
                </div>
                <div class="col-12">
                    <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block" :class="cargando && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'" :disabled="cargando">
                        Guardar
                    </button>
                </div>
                <div class="col-12 p-4">
                    <small class="text-justify text-muted">
                        Para verificar el estado de su transacción puede acceder al detalle de pagos en su cuenta personal, en el botón de compras.
                    </small>
                </div>
            </div>
        </fieldset>
    </form>
</template>

<script>
    import archivo from "../boton-file";
    import comboBox from "../comboBox";
    import _ from 'lodash';
    import {catalogos, negociacion,persona} from "../../servicios";
    export default {
        name: "trasnferencia",
        components:{
            archivo,
            comboBox
        },
        props:{
            tipo:{
                type: Object,
                required:true,
            }
        },
        data:()=>({
            formulario:{
                archivo:null,
                monto:null,
                fecha:null,
                email:null,
                cuenta:null,
                comprobante:null,
                beneficiario:null,
                banco:{id:null,dt2:null,num:null},
            },
            lstBancos:[],
            cargando:false,
        }),
        methods:{
            validar:function(){
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.cargando=true;
                        if(!this.$store.getters.getCotizacion.bdt1){
                            this.mensajeLicitud();
                        }else{
                            this.enviarDatos();
                        }
                    }else{
                        this.$toast.show(`Completa el formulario`);
                        setTimeout(() => {
                            let container = this.$el.querySelector('.is-invalid');
                            container.scrollIntoView();
                        }, 100);
                    }
                });
            },
          mensajeLicitud:function(){
            const cotizacion = this.$store.getters.getCotizacion;
            const mensaje = cotizacion.bdt4 ? 'solicitud de credito' : 'licitud de fondos';
            this.$swal({
              html: `<b>Estimado cliente<br>Antes de continuar con su proceso  de pago, es importante realizar una aceptación de ${mensaje}, por lo que le pedimos tomarse un momento para llenar la siguiente declaración.</b>`,
              showLoaderOnConfirm: true,
              showCancelButton: true,
              confirmButtonText: 'Si',
              confirmButtonAriaLabel: 'No',
              cancelButtonText: 'No',
              cancelButtonAriaLabel: 'Si',
              preConfirm: () => {
                this.$router.push({name:cotizacion.bdt4 ? 'compras.credito.solicitud' : 'compras.contado.licitud'});
              }
            });
          },
            consultarBancos:function(){
                catalogos.listaCuentasAgencia().then(r=>r.data).then(bancos=>{
                    bancos.map(i=>{
                        i.num=i.dt1;
                        i.dt1=`${i.dt2} - ${i.dt1}`;
                        this.lstBancos.push(i);
                    });
                });
            },
            enviarDatos:_.debounce(function(){
                const cotizacion = this.$store.getters.getCotizacion;
                persona.validarDatos().then(()=> {
                    negociacion.nuevoPago(this.formulario,this.tipo).then(()=>{
                        this.cargando=false;
                        this.$router.push({name: cotizacion.bdt4 ? 'credito.detalle' : 'compras.detalle'});
                    }).catch(()=>{
                        this.cargando=false;
                    })
                }).catch(()=>{
                    this.cargando=false;
                    this.$toast.show(`Debes completar el paso 1`);
                });
            },2000)
        },
        computed:{
            minimaFecha:function(){
                return this.$moment().format("DD/MM/YYYY");
            },
            maximaFecha:function(){
                return this.$moment().add(-1,"month").format("DD/MM/YYYY");
            },
            maximo:function(){
                return (this.$store.getters.getCotizacion.ndt13).toFixed(2);
            },
          enabled:function() {
              return this.$store.getters.getCotizacion.bdt1
          }
        },
        created() {
            this.consultarBancos();
        },
    }
</script>

<style scoped>

</style>
